import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function PWAInstall() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isStandalone) return;
    const dismissed = localStorage.getItem('gtc_pwa_dismissed');
    if (dismissed) return;

    const ua = window.navigator.userAgent.toLowerCase();
    const ios = /iphone|ipad|ipod/.test(ua) && !window.MSStream;
    if (ios) {
      setIsIOS(true);
      setShowIOS(true);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    await prompt.userChoice;
    setVisible(false);
    localStorage.setItem('gtc_pwa_dismissed', '1');
  };

  const dismiss = () => {
    setVisible(false);
    setShowIOS(false);
    localStorage.setItem('gtc_pwa_dismissed', '1');
  };

  return (
    <AnimatePresence>
      {(visible || (isIOS && showIOS)) && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 20 }}
          className="fixed bottom-4 left-4 right-4 z-50 max-w-md mx-auto"
          data-testid="pwa-install-banner"
        >
          <div className="glass rounded-2xl p-4 flex items-center gap-3 gold-glow">
            <div className="w-10 h-10 rounded-full bg-[var(--gold-soft)] flex items-center justify-center">
              <Download className="w-5 h-5 text-[var(--gold)]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-heading text-white text-sm font-semibold">Aggiungi alla schermata Home</div>
              <div className="text-xs text-white/60 truncate">
                {isIOS ? 'Tocca Condividi → "Aggiungi a Home"' : 'Installa Golden TV come app nativa'}
              </div>
            </div>
            {!isIOS && (
              <button data-testid="pwa-install-btn" onClick={install} className="btn-gold px-4 py-2 text-sm">
                Installa
              </button>
            )}
            <button data-testid="pwa-dismiss-btn" onClick={dismiss} className="p-2 text-white/40 hover:text-white transition-colors">
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
